// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark .paylixecommerce-table table tbody tr td {
  border-top: 1px solid var(--black1) !important;
}
.dark .paylixecommerce-table table thead tr th {
  background: var(--black1);
}
.dark .paylixecommerce-table-pagination {
  border-top: 1px solid var(--black1) !important;
  background: var(--black1);
}
.dark .page-size-container .select-container {
  background-color: var(--white);
}

.paylixecommerce-table {
  width: 100%;
  overflow-x: auto;
}
.paylixecommerce-table-clear {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5rem;
}
.paylixecommerce-table-clear-icon {
  margin-bottom: 1.5rem;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 100%;
  background: var(--purple0);
  display: flex;
  align-items: center;
  justify-content: center;
}
.paylixecommerce-table-clear-icon svg {
  width: 1.5rem;
  height: 1.5rem;
}
.paylixecommerce-table-clear-title {
  margin-bottom: 0.5rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: var(--black9);
}
.paylixecommerce-table-clear-text {
  margin-bottom: 1.5rem;
  color: var(--black5);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
.paylixecommerce-table-container {
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
}
.paylixecommerce-table-container.cursor-pointer table tr td {
  cursor: pointer;
}
.paylixecommerce-table-container .paylixecommerce-table {
  background: var(--white);
  border-radius: 0.5rem 0.5rem 0 0;
}
.paylixecommerce-table-container.skip-pagination {
  border-radius: 0.5rem;
  box-shadow: none;
}
.paylixecommerce-table-container.skip-pagination .paylixecommerce-table {
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
}
.paylixecommerce-table-container.skip-pagination .paylixecommerce-table table {
  border-radius: 0.5rem;
}
.paylixecommerce-table tbody tr:nth-last-child(-n+3) .paylixecommerce-table-actions-modal {
  flex-direction: row;
  top: -1rem;
  right: 1.5rem;
  width: auto;
  transform: none;
}
.paylixecommerce-table table {
  border-radius: 0.5rem;
}
.paylixecommerce-table-container {
  width: 100%;
  max-width: 100%;
}
@media (max-width: 768px) {
  .paylixecommerce-table {
    overflow: scroll;
  }
}
.paylixecommerce-table-nothing {
  padding: 2rem 0;
  color: var(--black9);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
.paylixecommerce-table-actions {
  display: flex;
  justify-content: flex-end;
  position: relative;
  padding: 0.25rem 0.5rem;
}
.paylixecommerce-table-actions img:hover + div {
  display: flex;
}
.paylixecommerce-table-actions > div {
  position: absolute;
  top: 1rem;
  display: none;
}
.paylixecommerce-table-actions > img {
  cursor: pointer;
}
.paylixecommerce-table-actions:hover .paylixecommerce-table-actions-modal {
  display: flex;
}
.paylixecommerce-table-actions-modal {
  z-index: 9;
  position: absolute;
  top: calc(100% - 0.5rem);
  right: -5rem;
  display: none;
  flex-direction: column;
  width: 8rem;
  background: var(--white);
  transform: translateX(-50%);
  box-shadow: 0 4px 24px -4px rgba(0, 0, 0, 0.08);
  border-radius: 0.5rem;
  font-size: 14px;
  margin-top: 0.5rem;
  overflow: hidden;
  background: var(--white);
  border: none;
}
@media (max-width: 768px) {
  .paylixecommerce-table-actions-modal {
    flex-direction: row;
    width: auto;
    top: calc(50% - 25px) !important;
    right: 2rem;
    transform: none;
  }
}
.paylixecommerce-table-actions-modal > div, .paylixecommerce-table-actions-modal > a, .paylixecommerce-table-actions-modal > span {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 0.75rem;
  height: 36px;
  line-height: 36px;
  color: var(--black5) !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  white-space: nowrap;
}
.paylixecommerce-table-actions-modal > div span, .paylixecommerce-table-actions-modal > a span, .paylixecommerce-table-actions-modal > span span {
  margin-left: 0.5rem;
}
@media (max-width: 768px) {
  .paylixecommerce-table-actions-modal > div, .paylixecommerce-table-actions-modal > a, .paylixecommerce-table-actions-modal > span {
    padding: 1rem;
  }
  .paylixecommerce-table-actions-modal > div i, .paylixecommerce-table-actions-modal > a i, .paylixecommerce-table-actions-modal > span i {
    margin-right: 0 !important;
    font-size: 1rem;
  }
  .paylixecommerce-table-actions-modal > div > span, .paylixecommerce-table-actions-modal > a > span, .paylixecommerce-table-actions-modal > span > span {
    display: none;
  }
}
.paylixecommerce-table-actions-modal > div.delete-icon, .paylixecommerce-table-actions-modal > a.delete-icon, .paylixecommerce-table-actions-modal > span.delete-icon {
  color: var(--red6) !important;
}
.paylixecommerce-table-actions-modal > div.delete-icon:hover, .paylixecommerce-table-actions-modal > a.delete-icon:hover, .paylixecommerce-table-actions-modal > span.delete-icon:hover {
  color: var(--red6) !important;
  background: var(--red0);
}
.paylixecommerce-table-actions-modal > div:hover, .paylixecommerce-table-actions-modal > a:hover, .paylixecommerce-table-actions-modal > span:hover {
  color: var(--black9) !important;
  background: var(--black1);
}
.paylixecommerce-table-actions-modal > div img, .paylixecommerce-table-actions-modal > a img, .paylixecommerce-table-actions-modal > span img {
  margin-right: 0.75rem;
}
.paylixecommerce-table-actions-modal > div i, .paylixecommerce-table-actions-modal > a i, .paylixecommerce-table-actions-modal > span i {
  color: var(--black9);
  margin-right: 0.75rem;
}
.paylixecommerce-table-pagination {
  display: flex;
  justify-content: space-between;
  color: var(--black6);
  padding: 1rem 1.25rem;
  list-style: none;
  border-top: 1px solid var(--black0) !important;
  border-radius: 0 0 0.5rem 0.5rem;
  background-color: var(--white);
}
@media (max-width: 768px) {
  .paylixecommerce-table-pagination {
    flex-wrap: wrap;
    flex-direction: column-reverse;
  }
  .paylixecommerce-table-pagination .page-size-container {
    margin-bottom: 0;
  }
  .paylixecommerce-table-pagination > div {
    width: 100%;
    justify-content: center;
    margin-bottom: 1rem;
  }
}
.paylixecommerce-table-pagination button {
  width: 2rem;
  padding: 0;
}
.paylixecommerce-table-pagination button.active {
  border-color: var(--purple6);
  border-width: 2px;
}
.paylixecommerce-table-pagination button.active:hover {
  background-color: var(--white);
}
.paylixecommerce-table-pagination button.more svg {
  margin-top: 0.25rem;
}
.paylixecommerce-table-pagination .page-size-container .select-container {
  max-height: 2rem;
  height: 2rem;
}
.paylixecommerce-table-pagination .page-size-container > span {
  font-size: 13px;
  font-weight: 500;
  color: var(--black4);
}
.paylixecommerce-table-pagination > div {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
@media (max-width: 768px) {
  .paylixecommerce-table-pagination > div {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
.paylixecommerce-table-pagination .paylixecommerce-select {
  width: 7rem;
  height: 2rem;
  margin-left: 1rem;
  font-size: 0.8rem;
}
.paylixecommerce-table-pagination .paylixecommerce-input {
  width: 5rem;
  height: 2rem;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  background: var(--white);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
}
.paylixecommerce-table-pagination .paylixecommerce-input::-webkit-outer-spin-button, .paylixecommerce-table-pagination .paylixecommerce-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.paylixecommerce-table-pagination .paylixecommerce-input[type=number] {
  -moz-appearance: textfield;
}
.paylixecommerce-table table {
  background: var(--white);
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
  margin-bottom: 0;
  table-layout: auto;
  width: 100%;
}
.paylixecommerce-table table.last-right thead tr th:last-child {
  text-align: right;
}
.paylixecommerce-table table.last-right tbody tr td:last-child {
  text-align: right;
}
.paylixecommerce-table table.last-center thead tr th:last-child {
  text-align: center;
}
.paylixecommerce-table table.last-center tbody tr td:last-child {
  text-align: center;
}
.paylixecommerce-table table thead th {
  background: var(--white);
  color: var(--black4);
  padding: 0.875rem 0.75rem 0.875rem 1.25rem;
  border-bottom: none !important;
  border-top: none !important;
  cursor: pointer;
  white-space: nowrap;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
}
.paylixecommerce-table table thead th:first-child {
  padding-left: 1.25rem !important;
  border-radius: 0.5rem 0 0 0;
}
.paylixecommerce-table table thead th:last-child {
  padding-right: 1rem;
  border-radius: 0 0.5rem 0 0;
}
.paylixecommerce-table table thead th:focus {
  outline: none;
}
.paylixecommerce-table table tbody tr:last-child td:first-child {
  border-radius: 0 0 0 0.5rem;
}
.paylixecommerce-table table tbody tr:last-child td:last-child {
  border-radius: 0 0 0.5rem 0;
}
.paylixecommerce-table table tbody tr:hover {
  background: var(--black0);
}
.paylixecommerce-table table tbody tr:hover td {
  color: var(--black9);
}
.paylixecommerce-table table tbody tr td {
  vertical-align: middle;
  padding: 13px 0 !important;
  padding-left: 1.25rem !important;
  border: none;
  border-top: 1px solid var(--black0) !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: var(--black9);
}
.paylixecommerce-table table tbody tr td:first-child {
  padding-left: 1.25rem !important;
}
.paylixecommerce-table table tbody tr td:last-child {
  padding-right: 1.25rem !important;
}
.paylixecommerce-table table tbody tr td a {
  color: var(--black9);
}
.paylixecommerce-table table tbody tr td a:hover {
  color: #6461FC;
  text-decoration: none;
}
.paylixecommerce-table table tbody tr td a b {
  font-weight: 600;
}
.paylixecommerce-table::-webkit-scrollbar {
  width: 3px !important;
  height: 3px !important;
  background-color: transparent !important;
}
.paylixecommerce-table::-webkit-scrollbar-track {
  background-color: transparent !important;
}
.paylixecommerce-table::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3) !important;
}`, "",{"version":3,"sources":["webpack://./client/components/table2/index.scss"],"names":[],"mappings":"AACE;EACE,8CAAA;AAAJ;AAEE;EACE,yBAAA;AAAJ;AAGE;EACE,8CAAA;EACA,yBAAA;AADJ;AAKI;EACE,8BAAA;AAHN;;AAQA;EACE,WAAA;EACA,gBAAA;AALF;AAOE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AALJ;AAOI;EACE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALN;AAOM;EACE,aAAA;EACA,cAAA;AALR;AAQI;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AANN;AAQI;EACE,qBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AANN;AAUE;EACE,qBAAA;EACA,iFAAA;AARJ;AAUI;EACE,eAAA;AARN;AAWI;EACE,wBAAA;EACA,gCAAA;AATN;AAYI;EACE,qBAAA;EACA,gBAAA;AAVN;AAYM;EACE,qBAAA;EACA,iFAAA;AAVR;AAYQ;EACE,qBAAA;AAVV;AAoBQ;EACE,mBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AAlBV;AAwBE;EACE,qBAAA;AAtBJ;AAyBE;EACE,WAAA;EACA,eAAA;AAvBJ;AA0BE;EAlGF;IAmGI,gBAAA;EAvBF;AACF;AAyBE;EACE,eAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;AAxBJ;AA4BQ;EACE,aAAA;AA1BV;AA+BI;EACE,kBAAA;EACA,SAAA;EACA,aAAA;AA7BN;AAgCI;EACE,eAAA;AA9BN;AAkCM;EACE,aAAA;AAhCR;AAoCI;EACE,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;EACA,2BAAA;EAEA,+CAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,YAAA;AAnCN;AAsCM;EApBF;IAqBI,mBAAA;IACA,WAAA;IACA,gCAAA;IACA,WAAA;IACA,eAAA;EAnCN;AACF;AAqCM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAnCR;AAqCQ;EACE,mBAAA;AAnCV;AAuCQ;EApBF;IAqBI,aAAA;EApCR;EAsCQ;IACE,0BAAA;IACA,eAAA;EApCV;EAuCQ;IACE,aAAA;EArCV;AACF;AAwCQ;EACE,6BAAA;AAtCV;AAwCU;EACE,6BAAA;EACA,uBAAA;AAtCZ;AA0CQ;EACE,+BAAA;EACA,yBAAA;AAxCV;AA2CQ;EACE,qBAAA;AAzCV;AA4CQ;EACE,oBAAA;EACA,qBAAA;AA1CV;AAiDE;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,8CAAA;EACA,gCAAA;EACA,8BAAA;AA/CJ;AAiDI;EAVF;IAWI,eAAA;IACA,8BAAA;EA9CJ;EAgDI;IACE,gBAAA;EA9CN;EAiDI;IACE,WAAA;IACA,uBAAA;IACA,mBAAA;EA/CN;AACF;AAkDI;EACE,WAAA;EACA,UAAA;AAhDN;AAmDI;EACE,4BAAA;EACA,iBAAA;AAjDN;AAmDM;EACE,8BAAA;AAjDR;AAqDI;EACE,mBAAA;AAnDN;AAwDM;EACE,gBAAA;EACA,YAAA;AAtDR;AAyDM;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AAvDR;AA2DI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAzDN;AA2DM;EALF;IAMI,eAAA;IACA,WAAA;EAxDN;AACF;AA2DI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAzDN;AA4DI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AA3DN;AA8DM;EACE,wBAAA;EACA,SAAA;AA5DR;AA8DM;EACE,0BAAA;AA5DR;AAiEE;EACE,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AA/DJ;AAkEM;EACE,iBAAA;AAhER;AAkEM;EACE,iBAAA;AAhER;AAqEM;EACE,kBAAA;AAnER;AAqEM;EACE,kBAAA;AAnER;AAwEM;EACE,wBAAA;EACA,oBAAA;EACA,0CAAA;EACA,8BAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAtER;AA4EQ;EACE,gCAAA;EACA,2BAAA;AA1EV;AA4EQ;EACE,mBAAA;EACA,2BAAA;AA1EV;AA6EQ;EACE,aAAA;AA3EV;AAqFU;EACE,2BAAA;AAnFZ;AAqFU;EACE,2BAAA;AAnFZ;AAuFQ;EACE,yBAAA;AArFV;AAuFU;EACE,oBAAA;AArFZ;AAyFQ;EACE,sBAAA;EACA,0BAAA;EACA,gCAAA;EACA,YAAA;EACA,8CAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAvFV;AAyFU;EACE,gCAAA;AAvFZ;AAyFU;EACE,iCAAA;AAvFZ;AA0FU;EACE,oBAAA;AAxFZ;AA0FY;EACE,cAAA;EACA,qBAAA;AAxFd;AA2FY;EACE,gBAAA;AAzFd;AAkGE;EACE,qBAAA;EACA,sBAAA;EACA,wCAAA;AAhGJ;AAmGE;EACE,wCAAA;AAjGJ;AAoGE;EACE,+CAAA;AAlGJ","sourcesContent":[".dark {\n  .paylixecommerce-table table tbody tr td {\n    border-top: 1px solid var(--black1) !important;\n  }\n  .paylixecommerce-table table thead tr th {\n    background: var(--black1);\n  }\n\n  .paylixecommerce-table-pagination {\n    border-top: 1px solid var(--black1) !important;\n    background: var(--black1);\n  }\n\n  .page-size-container {\n    .select-container {\n      background-color: var(--white);\n    }\n  }\n}\n\n.paylixecommerce-table {\n  width: 100%;\n  overflow-x: auto;\n\n  &-clear {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 5rem;\n\n    &-icon {\n      margin-bottom: 1.5rem;\n      width: 3.5rem;\n      height: 3.5rem;\n      border-radius: 100%;\n      background: var(--purple0);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      svg {\n        width: 1.5rem;\n        height: 1.5rem;\n      }\n    }\n    &-title {\n      margin-bottom: .5rem;\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 19px;\n      text-align: center;\n      color: var(--black9);\n    }\n    &-text {\n      margin-bottom: 1.5rem;\n      color: var(--black5);\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 20px;\n    }\n  }\n\n  &-container {\n    border-radius: .5rem;\n    box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n\n    &.cursor-pointer table tr td {\n      cursor: pointer;\n    }\n\n    .paylixecommerce-table {\n      background: var(--white);\n      border-radius: .5rem .5rem 0 0;\n    }\n\n    &.skip-pagination {\n      border-radius: .5rem;\n      box-shadow: none;\n\n      .paylixecommerce-table {\n        border-radius: .5rem;\n        box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n\n        table {\n          border-radius: .5rem;\n        }\n      }\n    }\n  }\n\n  tbody {\n\n    tr {\n      &:nth-last-child(-n+3) {\n        .paylixecommerce-table-actions-modal {\n          flex-direction: row;\n          top: -1rem;\n          right: 1.5rem;\n          width: auto;\n          transform: none;\n        }\n      }\n    }\n  }\n\n  table {\n    border-radius: 0.5rem;\n  }\n\n  &-container {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  @media (max-width: 768px) {\n    overflow: scroll;\n  }\n\n  &-nothing {\n    padding: 2rem 0;\n    color: var(--black9);\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  &-actions {\n    display: flex;\n    justify-content: flex-end;\n    position: relative;\n    padding: .25rem .5rem;\n\n    img {\n      &:hover {\n        & + div {\n          display: flex;\n        }\n      }\n    }\n\n    & > div {\n      position: absolute;\n      top: 1rem;\n      display: none;\n    }\n\n    & > img {\n      cursor: pointer;\n    }\n\n    &:hover {\n      .paylixecommerce-table-actions-modal {\n        display: flex;\n      }\n    }\n\n    &-modal {\n      z-index: 9;\n      position: absolute;\n      top: calc(100% - .5rem);\n      right: -5rem;\n      display: none;\n      flex-direction: column;\n      width: 8rem;\n      background: var(--white);\n      transform: translateX(-50%);\n\n      box-shadow: 0 4px 24px -4px rgba(0, 0, 0, 0.08);\n      border-radius: .5rem;\n      font-size: 14px;\n      margin-top: .5rem;\n      overflow: hidden;\n      background: var(--white);\n      border: none;\n\n\n      @media (max-width: 768px) {\n        flex-direction: row;\n        width: auto;\n        top: calc(50% - 25px) !important;\n        right: 2rem;\n        transform: none;\n      }\n\n      & > div, & > a, & > span {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        padding: 0 0.75rem;\n        height: 36px;\n        line-height: 36px;\n        color: var(--black5) !important;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 13px;\n        white-space: nowrap;\n\n        span {\n          margin-left: .5rem;\n        }\n\n\n        @media (max-width: 768px) {\n          padding: 1rem;\n\n          i {\n            margin-right: 0 !important;\n            font-size: 1rem;\n          }\n\n          & > span {\n            display: none;\n          }\n        }\n\n        &.delete-icon {\n          color: var(--red6) !important;\n\n          &:hover {\n            color: var(--red6) !important;\n            background: var(--red0);\n          }\n        }\n\n        &:hover {\n          color: var(--black9) !important;\n          background: var(--black1);\n        }\n\n        img {\n          margin-right: .75rem;\n        }\n\n        i {\n          color: var(--black9);\n          margin-right: .75rem;\n        }\n      }\n    }\n\n  }\n\n  &-pagination {\n    display: flex;\n    justify-content: space-between;\n    color: var(--black6);\n    padding: 1rem 1.25rem;\n    list-style: none;\n    border-top: 1px solid var(--black0) !important;\n    border-radius: 0 0 .5rem .5rem;\n    background-color: var(--white);\n\n    @media (max-width: 768px) {\n      flex-wrap: wrap;\n      flex-direction: column-reverse;\n\n      .page-size-container {\n        margin-bottom: 0;\n      }\n\n      & > div {\n        width: 100%;\n        justify-content: center;\n        margin-bottom: 1rem;\n      }\n    }\n\n    button {\n      width: 2rem;\n      padding: 0;\n    }\n\n    button.active {\n      border-color: var(--purple6);\n      border-width: 2px;\n\n      &:hover {\n        background-color: var(--white);\n      }\n    }\n\n    button.more svg {\n      margin-top: 0.25rem;\n    }\n\n    .page-size-container {\n\n      .select-container {\n        max-height: 2rem;\n        height: 2rem;\n      }\n\n      > span {\n        font-size: 13px;\n        font-weight: 500;\n        color: var(--black4);\n      }\n    }\n\n    & > div {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n\n      @media (max-width: 768px) {\n        flex-wrap: wrap;\n        gap: .5rem;\n      }\n    }\n\n    .paylixecommerce-select {\n      width: 7rem;\n      height: 2rem;\n      margin-left: 1rem;\n      font-size: .8rem;\n    }\n\n    .paylixecommerce-input {\n      width: 5rem;\n      height: 2rem;\n      text-align: center;\n      justify-content: center;\n      align-items: center;\n      display: flex;\n      background: var(--white);\n\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 17px;\n      color: var(--black9);\n\n\n      &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n      &[type=number]{\n        -moz-appearance: textfield;\n      }\n    }\n  }\n\n  table {\n    background: var(--white);\n    border-radius: .5rem .5rem .5rem .5rem;\n    margin-bottom: 0;\n    table-layout: auto;\n    width: 100%;\n\n    &.last-right {\n      thead tr th:last-child {\n        text-align: right;\n      }\n      tbody tr td:last-child {\n        text-align: right;\n      }\n    }\n\n    &.last-center {\n      thead tr th:last-child {\n        text-align: center;\n      }\n      tbody tr td:last-child {\n        text-align: center;\n      }\n    }\n\n    thead {\n      th {\n        background: var(--white);\n        color: var(--black4);\n        padding: 0.875rem .75rem 0.875rem 1.25rem;\n        border-bottom: none !important;\n        border-top: none !important;\n        cursor: pointer;\n        white-space: nowrap;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 13px;\n        line-height: 16px;\n\n        & > span {\n          //display: none;\n        }\n\n        &:first-child {\n          padding-left: 1.25rem !important;\n          border-radius: .5rem 0 0 0;\n        }\n        &:last-child {\n          padding-right: 1rem;\n          border-radius: 0 .5rem 0 0;\n        }\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n\n    tbody {\n\n      tr {\n\n        &:last-child {\n          td:first-child {\n            border-radius: 0 0 0 .5rem;\n          }\n          td:last-child {\n            border-radius: 0 0 .5rem 0;\n          }\n        }\n\n        &:hover {\n          background: var(--black0);\n\n          td {\n            color: var(--black9);\n          }\n        }\n\n        td {\n          vertical-align: middle;\n          padding: 13px 0 !important;\n          padding-left: 1.25rem !important;\n          border: none;\n          border-top: 1px solid var(--black0) !important;\n          font-family: 'Inter';\n          font-style: normal;\n          font-weight: 500;\n          font-size: 13px;\n          line-height: 16px;\n          color: var(--black9);\n\n          &:first-child {\n            padding-left: 1.25rem !important;\n          }\n          &:last-child {\n            padding-right: 1.25rem !important;\n          }\n\n          a {\n            color: var(--black9);\n\n            &:hover {\n              color: #6461FC;\n              text-decoration: none;\n            }\n\n            b {\n              font-weight: 600;\n            }\n          }\n        }\n      }\n    }\n  };\n\n\n  &::-webkit-scrollbar {\n    width: 3px !important;\n    height: 3px !important;\n    background-color: transparent !important;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: transparent !important;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(0,0,0,0.3) !important;\n  }\n\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
